// todo: will load the drop down menu dynamically from back-end
import { Region } from "src/app/constant/Enums";
import { DropDownOption } from "src/app/model/DropDownOption";

export const NA_COUNTRY_OPTION = [{
    name: 'US',
    value: 'US'
}, {
    name: 'CA',
    value: 'CA'
}, {
    name: 'MX',
    value: 'MX'
}, {
    name: 'BR',
    value: 'BR'
}
];

export const EU_COUNTRY_OPTION = [{
    name: 'GB',
    value: 'GB'
}, {
    name: 'IN',
    value: 'IN'
}
];

export const FE_COUNTRY_OPTION = [{
    name: 'JP',
    value: 'JP'
}, {
    name: 'AU',
    value: 'AU'
}, {
    name: 'SG',
    value: 'SG'
}
];

const REGION_COUNTRY_CONFIG: Map<Region, DropDownOption[]> = new Map();
REGION_COUNTRY_CONFIG.set(Region.NA, NA_COUNTRY_OPTION);
REGION_COUNTRY_CONFIG.set(Region.EU, EU_COUNTRY_OPTION);
REGION_COUNTRY_CONFIG.set(Region.FE, FE_COUNTRY_OPTION);

export const STATUS_OPTION = [{
    name: 'PENDING',
    value: 'PENDING'
}, {
    name: 'COMPLETED',
    value: 'COMPLETED'
}, {
    name: 'PAUSED',
    value: 'PAUSED'
}
];

export const TRANSPORTER_TYPE_OPTION = [{
    name: 'DP',
    value: 'DP'
}
];

export const CASE_TYPE_OPTION = [{
    /*
        Abuse is the case type for BWND and OPF enforcements cases.
     */
    name: 'Abuse',
    value: 'Abuse'
}, {
    name: 'AMCEagle',
    value: 'AMCEagle'
}, {
    name: 'ID_Fraud',
    value: 'ID_Fraud'
}, {
    name: 'DPW_Compliance',
    value: 'DPW_Compliance'
}, {
    name: 'DUPLICATE_ACCOUNT',
    value: 'DUPLICATE_ACCOUNT'
}, {
    name: 'OTR_UTR_Fraud',
    value: 'OTR_UTR_Fraud'
}
, {
    name: 'Standings',
    value: 'Standings'
}
];

/**
 *  This map stores the list of possible caseSubTypes for each caseType
 */
export const CASE_TYPE_TO_CASE_SUB_TYPE_MAP: { [key: string]: DropDownOption[] } = {
    'Abuse': [
        {
            name: 'BWND',
            value: 'BWND'
        },
        {
            name: 'OPF',
            value: 'OPF'
        }
    ],
    'AMCEagle': [
        {
            name: 'AMCEagle',
            value: 'AMCEagle'
        }
    ],
    'ID_Fraud': [
        {
            name: 'DL_Fraud',
            value: 'DL_Fraud'
        },
        {
            // Sentinel Verification (selfie identity) enforcement; enum value from EagleEyeCommonModel.
            name: 'SentinelVerification',
            value: 'SentinelVerification'
        }
    ],
    'DUPLICATE_ACCOUNT': [
        {
            name: 'Identical_Account_Fraud',
            value: 'Identical_Account_Fraud'
        },
        {
            name: 'Cross_platform',
            value: 'Cross_platform'
        },
        {
            name: 'Identical_Account_Non_Fraud',
            value: 'Identical_Account_Non_Fraud'
        }
    ],
    'DPW_Compliance': [
        {
            name: 'Inactivity',
            value: 'Inactivity'
        }
    ],
    'OTR_UTR_Fraud': [
        {
            name: 'ONA',
            value: 'ONA'
        },
        {
            name: 'ONP',
            value: 'ONP'
        },
        {
            name: 'RCA',
            value: 'RCA'
        }
    ],
    'Standings': [
        {
            name: 'ODQ',
            value: 'ODQ'
        },
        {
            name: 'Reliability',
            value: 'Reliability'
        }
    ]
};

export const REVIEW_TYPE_OPTION = [{
    name: 'PRIMARY_AUDIT',
    value: 'PRIMARY_AUDIT'
}, {
    name: 'SECONDARY_AUDIT',
    value: 'SECONDARY_AUDIT'
}, 
{
    name: 'REOPEN_AUDIT',
    value: 'REOPEN_AUDIT'
}
];

export const CASE_DECISION_REASON_CODE_CONFIG: { [key: string]: DropDownOption[] } = {
    'Abuse': [{
        name: 'SUSPECTED_FRAUD',
        value: 'SUSPECTED_FRAUD'
    }],
    'AMCEagle': [{
        name: 'TEMPORARY_DEACTIVATION',
        value: 'TEMPORARY_DEACTIVATION'
    }],
    'ID_Fraud': [{
        name: 'DRIVER_LICENSE_UPLOAD_FAILURE',
        value: 'DRIVER_LICENSE_UPLOAD_FAILURE'
    }],
    'DPW_Compliance': [{
        name: 'INACTIVITY_TIMEOUT',
        value: 'INACTIVITY_TIMEOUT'
    }],
    'DUPLICATE_ACCOUNT': [
        {
            name: 'SUSPECTED_FRAUD_DUPLICATE_ACCOUNT',
            value: 'SUSPECTED_FRAUD_DUPLICATE_ACCOUNT'
        },
        {
            name: 'DUPLICATE_ACCOUNT_REUSABLE',
            value: 'DUPLICATE_ACCOUNT_REUSABLE'
        },
        {
            name: 'CROSS_PLATFORM',
            value: 'CROSS_PLATFORM'
        }
    ],
    'OTR_UTR_Fraud': [{
        name: 'SUSPECTED_FRAUD',
        value: 'SUSPECTED_FRAUD'
    }]
};

export const DEFAULT_REASON_CODE_OPTION = [{
    name: 'SUSPECTED_FRAUD',
    value: 'SUSPECTED_FRAUD'
}]

/**
 * ODQ/Reliability offboard-decision dropdowns (auditor-selected in the OffboardDecisionModal).
 * reasonCode is mandatory for both ODQ and Reliability; rootCause is mandatory for ODQ only.
 * Shape is {value, title} to match the shared CustomDropdown component.
 */
export const ODQ_RELIABILITY_OFFBOARD_REASON_CODES = [
    {value: 'SERVICE_LEVEL_STANDARDS_VIOLATION', title: 'SERVICE_LEVEL_STANDARDS_VIOLATION'},
];

export const ODQ_OFFBOARD_ROOT_CAUSES = [
    {value: 'Offboarding - Overall Delivery Quality', title: 'Offboarding - Overall Delivery Quality'},
    {value: 'Offboarding - RTS Egregious', title: 'Offboarding - RTS Egregious'},
    {value: 'Non SSR Offboarding', title: 'Non SSR Offboarding'},
];

export { REGION_COUNTRY_CONFIG }
